import React from "react";
import moment from "moment";
import styled from "styled-components";
import { Link } from "react-admin";
import { filter, map, curry, propEq, allPass, path, isEmpty } from "ramda";
import * as R from "ramda";
import WeekBoard from "./weekBoard";
import { connect } from "react-redux";

// icons
import Info from "@material-ui/icons/Info";
import ArrowForward from "@material-ui/icons/ArrowForward";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Navigation from "@material-ui/icons/Navigation";
import Pantool from "@material-ui/icons/PanTool";
import Polymer from "@material-ui/icons/Polymer";
import Face from "@material-ui/icons/Face";
import EventSeat from "@material-ui/icons/EventSeat";
import SimplePopOver from "./simplePopOver";
import InfoPopOver from "./infoPopOver";
import Description from "@material-ui/icons/Description";
import Help from "@material-ui/icons/Help";
import Announcement from "@material-ui/icons/Announcement";
import Print from "@material-ui/icons/Print";
import LocalGasStation from "@material-ui/icons/LocalGasStation";
import FolderShared from "@material-ui/icons/FolderShared";
import { API_ROOT } from "../api-config";
import ProfileCompleteMark from "./profileCompleteMark";
import ClientDocumentsModal from "./ClientDocumentsModal";
import { documentTarget } from "../utils/agencyRiderDocuments";



const StyledDescription = styled(Description)({
  fontSize: "19px !important"
});

const StyledInfo = styled(Info)({
  fontSize: "19px !important"
});

const StyledAnnouncement = styled(Announcement)({
  fontSize: "19px !important"
});

const StyledHelp = styled(Help)({
  fontSize: "19px !important"
});

const Section = styled.div({
  backgroundColor: "grey",
  color: "white",
  padding: "4px"
});

const StyledOptionsHeader = styled.div({
  display: "flex"
});

const StyledOptions = styled.div({
  justifyContent: "flex-end",
  display: "flex",
  flexGrow: "1"
});

const StyledArrowForward = styled(ArrowForward)({
  color: "red !important",
  fontSize: "40px !important"
});

const StyledArrowBack = styled(ArrowBack)({
  color: "green !important",
  fontSize: "40px !important"
});

const ArrowsRow = styled.div({
  display: "flex",
  justifyContent: "flex-end",
  paddingBottom: "5px",
  borderBottom: "1px solid black",
  marginBottom: "5px"
});

const Row = styled.div({
  display: "flex",
  marginTop: "4px"
});

class RentalAgendaCard extends React.Component {
  constructor() {
    super();
    this.offset = 0; 
    this.componentRef = React.createRef();
    this.state = {
      clientDocumentsModalOpen: false,
      documentsClientId: null,
      documentsRentalId: null,
    };
  }

  clientIdOf = rental => documentTarget(rental).clientId;

  openClientDocuments = (rental, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const target = documentTarget(rental);
    if (!target.clientId && !target.rentalId) return;
    this.setState({
      clientDocumentsModalOpen: true,
      documentsClientId: target.clientId,
      documentsRentalId: target.rentalId,
    });
  };

  closeClientDocuments = () => {
    this.setState({
      clientDocumentsModalOpen: false,
      documentsClientId: null,
      documentsRentalId: null,
    });
  };

  renderDocumentsIcon = rental => {
    const target = documentTarget(rental);
    if (!target.clientId && !target.rentalId) return null;
    return (
      <span
        title="View / upload client documents"
        alt="View / upload client documents"
        onClick={e => this.openClientDocuments(rental, e)}
        style={{
          cursor: "pointer",
          marginLeft: 4,
          display: "inline-flex",
          verticalAlign: "middle",
          color: "#555",
        }}
      >
        <FolderShared style={{ fontSize: 18 }} />
      </span>
    );
  };

  openPdfByRentalDayAndLocation = async (rentalDay, locationId, type, guide) => {
    await fetch(
      `${API_ROOT}/generate_rental_contract/?type=${type}&location_id=${locationId}&day=${moment(
        rentalDay._d
      ).format("YYYY-MM-DD")}&guide=${guide}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.token}`
        }
      }
    )
      .then(async res => {
        const file = await res.blob();

        var reader = new FileReader();
        reader.readAsDataURL(file); //Convert the blob from clipboard to base64
        reader.onload = function (event) {
          const pdfDoc = reader.result.replace("octet-stream", "pdf");
          let a = document.createElement("a");
          a.href = pdfDoc;

          a.download = `${type === 1 ? "tour" : "rental"}-${moment(
            rentalDay._d
          ).format("YYYY-MM-DD")}.pdf`;
          a.click();
          a.remove();
        };
      })

      .catch(err => {
        console.error(err);
      });
  };

  openPdfByRentalId = async (rentalId, type) => {
    await fetch(
      `${API_ROOT}/generate_rental_contract/${rentalId}?type=${type}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.token}`
        }
      }
    )
      .then(async res => {
        const file = await res.blob();

        var reader = new FileReader();
        reader.readAsDataURL(file); //Convert the blob from clipboard to base64
        reader.onload = async function (event) {
          const pdfDoc = reader.result.replace("octet-stream", "pdf");
          let a = document.createElement("a");
          a.href = pdfDoc;
          a.download = `${type === 1 ? "tour" : "rental"}-${rentalId}.pdf`;
          a.click();
          a.remove();
        };
      })

      .catch(err => {
        console.error(err);
      });
  };
  
  buildLinkContract = (rental, type) => {
    return (
      <Link
        to="#"
        alt="View Contract"
        title="View Contract"
        onClick={() => this.openPdfByRentalId(rental.id, type)}
      >
        <StyledDescription />
      </Link>
    );
  };

  buildLinkContracts = (rentalDay, locationId, type) => {
    return (
      <div
        style={{
          paddingRight: "10px",
          paddingBottom: "25px",
          paddingTop: "10px"
        }}
      >
        <Link
          to="#"
          alt="View all Contracts"
          title="View all Contracts"
          style={{ float: "right", height: "25px" }}
          onClick={() =>
            this.openPdfByRentalDayAndLocation(rentalDay, locationId, type, false)
          }
        >
          <Print style={{ height: "20px" }} /> Tours
        </Link>
      </div>
    );
  };
  
  buildLinkContractsGuide = (rentalDay, locationId, type) => {
    return (
      <div
        style={{
          paddingRight: "10px",
          paddingBottom: "25px",
          paddingTop: "10px"
        }}
      >
        <Link
          to="#"
          alt="View all Contracts - Guide"
          title="View all Contracts"
          style={{ float: "right", height: "25px" }}
          onClick={() =>
            this.openPdfByRentalDayAndLocation(rentalDay, locationId, type, true)
          }
        >
          <Print style={{ height: "20px" }} /> Tours Guide
        </Link>
      </div>
    );
  };

  buildLinkForVehicle = vehicle => {
    return (
      <div>
        <Link to={{ pathname: `/history/${vehicle.id}` }} target="_blank">
          {vehicle.licence_plate} {vehicle.renting ? "®" : ""}
        </Link>
      </div>
    );
  };
  buildLinkForVehicleGuide = vehicle => {
    return (
      <div>
        <Link to={{ pathname: `/history/${vehicle.vehicle_id}` }} target="_blank">
          {vehicle.licence_plate} {vehicle.renting ? "®" : ""}
        </Link>
      </div>
    );
  };

  buildLinkForTour = tourBike => {
    return (
      <div>
        <Link to={{ pathname: `/tours/${tourBike.tour_id}` }} target="_blank">
          <StyledInfo />
        </Link>
      </div>
    );
  };

  buildLinkForRental = (rental, type) => {
    let days;

    if(rental.type === 1){
      days = this.tourDuration(
        rental.date_1,
        rental.booking.tour.effective_end_date
      )
    }else{
      days = this.duration(
        rental.date_1,
        rental.time_1,
        rental.date_2,
        rental.time_2
      );
    }

    // const days = moment(rental.date_2).diff(moment(rental.date_1), "days");
    const booking = rental.booking || {};
    const clientName = [booking.r_first_name, booking.r_last_name]
      .filter(Boolean)
      .join(" ");

    return (
      <div>
        {clientName ? (
          <span style={{ marginRight: 6 }}>
            {clientName}
            {this.renderDocumentsIcon(rental)}
          </span>
        ) : (
          this.renderDocumentsIcon(rental)
        )}
        <Link
          to={{
            pathname: `/${type === 1 ? "tour" : "rental"}_clients/${rental.id
              }/show`
          }}
          target="_blank"
        >
          (#{rental.id} - {days} days)
        </Link>
      </div>
    );
  };

  buildLinkForTransfer = tranfer => {
    return (
      <div>
        <Link to={{ pathname: `/transfers/${tranfer.id}` }} target="_blank">
          See transfer
        </Link>
      </div>
    );
  };
  isLocationOut = (l1, l2) => {
    const result = propEq("location_id_2", l1, l2);
    return result;
  };

  isLocationIn = (l1, l2) => {
    const result = propEq("location_id_1", l1, l2);
    return result;
  };

  isMorning = (field, rental) => propEq(field, "10:00:00", rental);
  isAfternoon = (field, rental) => {
    const time = rental[field];
    return time === "18:00:00" || time === "15:00:00";
  };
  isIncoming = (day, rental) => day.isSame(moment.utc(rental.date_1), "day");
  isOutcomming = (day, rental) => day.isSame(moment.utc(rental.date_2), "day");
  // para guide bike
  isIncomingGuide = (day, rental) => day.isSame(moment.utc(rental.tour_start_date), "day");
  isOutcommingGuide = (day, rental) => day.isSame(moment.utc(rental.tour_end_date), "day");

  isIncommingTourDate = (day, rental) => {
    const tour = path(["booking", "tour"], rental);
    return day.isSame(tour.effective_end_date, "day");
  };

  isOutcommingTourDate = (day, rental) => {
    const tour = path(["booking", "tour"], rental);

    let date = null
    if(tour === undefined){
      //date = rental.tour_start_date
    }
    else{
      date = day.isSame(moment.utc(rental.date_1), "day")
    }
    return date
  };

  renderDayTransferLineVehicles = vehicle => {
    return (
      <React.Fragment key={`raf_${vehicle.id}`}>
        <div key={`m_${vehicle.model.id}`}>
          {" "}
          {vehicle.model.model_name} ({vehicle.vehicle_color})
        </div>
        {this.buildLinkForVehicle(vehicle)}
        <div key={`c_${vehicle.model.id}`}> {vehicle.model.vehicle_color} </div>
      </React.Fragment>
    );
  };

  renderDayGuideLineVehicles = vehicle => {
    let cont = 0 
    const bike = vehicle
    cont++
    return (
      <React.Fragment key={`raf_${cont}`}>
         <div key={`m_${bike.id}`}>
          {" "}
          {bike.model_name} ({bike.vehicle_color})
        </div>  
         {this.buildLinkForVehicleGuide(vehicle)}  
        {/* <div key={`c_${vehicle.vehicle_model_id}`}> {vehicle.vehicle_color} </div> */}
      </React.Fragment>
    );
  };

  renderDayTransfers = (location, transfer) => {
    if (transfer) {
      return (
        <div
          style={{ backgroundColor: "#fff5f5" }}
          key={`t_${location.id}_${transfer.id}`}
        >
          <React.Fragment>
            {this.buildLinkForTransfer(transfer)}
            {map(this.renderDayTransferLineVehicles, transfer.vehicles)}
            <ArrowsRow>
              {location !== transfer.location_id_2 ? (
                <StyledArrowForward />
              ) : (
                <StyledArrowBack style={{ color: "green" }} />
              )}
            </ArrowsRow>
          </React.Fragment>
        </div>
      );
    }
    return null;
  };

  renderDayGuideBike = (location, guideBike) => {
      if (guideBike) {
          return (
            <div
              style={{ backgroundColor: "#fff5f5" }}
              key={`t_${location.id}_${guideBike.id}`}
            >
              <React.Fragment>
                {this.renderDayGuideLineVehicles(guideBike)} 
                <ArrowsRow></ArrowsRow>
              </React.Fragment>
            </div>
          );
    } 
    return null;
  };

  renderGpsTour = (isOutcommingTour, tour, tourGpsDevice) => {
    return (
      <React.Fragment key={tourGpsDevice.id}>
        <div
          key={tourGpsDevice.gps_device.id}
          style={{ backgroundColor: "lightyellow" }}
        >
          <div>
            {tourGpsDevice.gps_device.model}
            <br /> Guide GPS
            <InfoPopOver
              key={`td_${tourGpsDevice.gps_device.id}`}
              header="Tour Info"
              text={`** ${R.path(["tour_name", "tour_name_en"], tour)} -- 
              ${moment(tour.effective_start_date).format("MMM")}
              ${moment(tour.effective_start_date).format("DD")} -
              ${moment(tour.effective_end_date).format("DD")}
              ${moment(tour.effective_end_date).format("YYYY")} **`}
              iconImage={StyledHelp}
            />
          </div>
          <ArrowsRow>
            {isOutcommingTour ? <StyledArrowForward /> : <StyledArrowBack />}
          </ArrowsRow>
        </div>
      </React.Fragment>
    );
  };

  renderVehicleTour = (isOutcommingTour, tour, tourBike) => {
    return (
      <React.Fragment key={tourBike.id}>
        <div key={tourBike.id} style={{ backgroundColor: "lightyellow" }}>
          <div>
            {tourBike.vehicle.model.model_name} (
            {tourBike.vehicle.vehicle_color || "WHITE"})<br />
            {this.buildLinkForVehicle(tourBike.vehicle)}
            {tourBike.vehicle.model.vehicle_type_id === 1
              ? "Guide Van"
              : "Guide Bike"}{" "}
            <InfoPopOver
              key={`t_${tourBike.id}`}
              header="Tour Info"
              text={`** ${R.path(["tour_name", "tour_name_en"], tour)} -- 
              ${moment(tour.effective_start_date).format("MMM")}
              ${moment(tour.effective_start_date).format("DD")} -
              ${moment(tour.effective_end_date).format("DD")}
              ${moment(tour.effective_end_date).format("YYYY")} **`}
              iconImage={StyledHelp}
            />
            {/* {this.buildLinkForTour(tourBike)} */}
          </div>
          <ArrowsRow>
            {isOutcommingTour ? <StyledArrowForward /> : <StyledArrowBack />}
          </ArrowsRow>
        </div>
      </React.Fragment>
    );
  };

  isAgencyRental = rental =>
    !!(rental && (rental.from_agency || (rental.booking && rental.booking.from_agency)));

  getRentalBlockStyle = rental => {
    if (this.isAgencyRental(rental)) {
      return { backgroundColor: "#FFFF00" };
    }
    if (rental.type === 1) {
      const selfGuided = path(["booking", "tour", "self_guided"], rental);
      return { backgroundColor: selfGuided ? "#fde7be" : "lightyellow" };
    }
    return {};
  };

  renderRental = (isOutcomming, rental) => {
    return (
      <React.Fragment key={rental.id}>
        <div
          key={rental.id}
          style={this.getRentalBlockStyle(rental)}
        >
          <StyledOptionsHeader>
            {R.isEmpty(rental.vehicle) && <span>Own Motorcycle</span>}
            {!R.isEmpty(rental.vehicle) && (
              <span>
                {rental.vehicle[0].model.model_name} (
                {rental.vehicle[0].vehicle_color}){" "}
              </span>
            )}

            <StyledOptions>
              <ProfileCompleteMark record={rental} />
              {this.buildLinkContract(rental, rental.type)}
              {!R.isEmpty(rental.extra_comments) &&
                !R.isNil(rental.extra_comments) && (
                  <InfoPopOver
                    key={`a1_${rental.id}`}
                    header="Internal Comments"
                    text={rental.extra_comments}
                    iconImage={StyledAnnouncement}
                  />
                )}
              <InfoPopOver
                key={`tk_${rental.id}`}
                header="Client Contacts"
                text={
                  <span>
                    {rental.booking.r_first_name} {rental.booking.r_last_name}
                    <br />
                    {rental.booking.r_home_phone}
                    <br />
                    {rental.booking.r_email}
                  </span>
                }
                iconImage={StyledInfo}
              />
            </StyledOptions>
          </StyledOptionsHeader>
          {this.buildLinkForRental(rental, rental.type)}
          {!R.isEmpty(rental.vehicle) &&
            this.buildLinkForVehicle(rental.vehicle[0])}
          <div> </div>
          <Row id={rental.id} key={rental.id}>
            <SimplePopOver
              key={`a_${rental.id}`}
              itemText="Selected tankbag"
              items={rental.tankbag}
              iconImage={LocalGasStation}
            />
            <SimplePopOver
              key={`b_${rental.id}`}
              showNumber="1"
              itemText="Selected gps device"
              items={rental.device}
              iconImage={Navigation}
            />
            <SimplePopOver
              key={`c_${rental.id}`}
              itemText="Selected glove(s)"
              items={rental.glove}
              iconImage={Pantool}
            />
            <SimplePopOver
              key={`d_${rental.id}`}
              itemText="Selected jacket(s)"
              items={rental.jacket}
              iconImage={Polymer}
            />
            <SimplePopOver
              key={`e_${rental.id}`}
              itemText="Selected helmet(s)"
              items={rental.helmet}
              iconImage={Face}
            />
            <SimplePopOver
              key={`f_${rental.id}`}
              itemText="Selected seat"
              items={rental.seat}
              iconImage={EventSeat}
            />
          </Row>
          <ArrowsRow>
            {isOutcomming ? <StyledArrowForward /> : <StyledArrowBack />}
          </ArrowsRow>
        </div>
      </React.Fragment>
    );
  };

  renderTours = (rentalTours, day, location, uniqueGuide) => {
    const dat = R.union(rentalTours, uniqueGuide)
    //console.log(dat) 

    const groupedData = R.groupBy(item => {
      const tourId = R.path(["booking", "tour", "id"], item);
      return tourId;
    }, rentalTours);
   
    if (R.length(rentalTours) > 0) {
      return (
        <React.Fragment>
          <br />
          {this.renderSection("TOURS", "#383f48")}
          {Object.values(groupedData).map(rentals => {
            const tour = R.path(["booking", "tour"], R.head(rentals));
            const tourVans = R.path(["tour_vans"], tour);
            const tourBikes = R.path(["tour_bikes"], tour);
            const tourGpsDevices = R.path(["tour_gps_devices"], tour);

            return (
              <React.Fragment key={tour.id}>
                {map(
                  curry(this.renderRental)(true),
                  filter(
                    allPass([curry(this.isOutcommingTourDate)(day)]),
                    rentals
                  )
                )}
                {moment(tour.effective_start_date).isSame(day) &&
                  map(curry(this.renderVehicleTour)(true, tour), tourBikes)}

                {moment(tour.effective_start_date).isSame(day) &&
                  map(curry(this.renderGpsTour)(true, tour), tourGpsDevices)}

                {moment(tour.effective_start_date).isSame(day) &&
                  map(curry(this.renderVehicleTour)(true, tour), tourVans)}

                {map(
                  curry(this.renderRental)(false),
                  filter(
                    allPass([curry(this.isIncommingTourDate)(day)]),
                    rentalTours
                  )
                )}

                {moment(tour.effective_end_date).isSame(day) &&
                  map(curry(this.renderVehicleTour)(false, tour), tourBikes)}

                {moment(tour.effective_end_date).isSame(day) &&
                  map(curry(this.renderVehicleTour)(false, tour), tourVans)}

                {moment(tour.effective_end_date).isSame(day) &&
                  map(curry(this.renderGpsTour)(false, tour), tourGpsDevices)}

                {filter(
                  allPass([
                    curry(this.isIncoming)(day),
                    curry(this.isLocationIn)(location),
                    curry(this.isLocationOut)(location)
                  ]),
                  rentalTours
                ).length >= 1
                  ? this.buildLinkContracts(day, location, 1)
                  : ""} 
              </React.Fragment>
            );
          })}
        </React.Fragment>
      );
    } else {
      return null;
    }
  };
  tourDuration = (date1, date2) => {
    let days = moment.utc(date2).diff(moment.utc(date1), "days") + 1
    return days
  }
  duration = (date1, time1, date2, time2) => {
    const days = moment(date2).diff(date1, "days");
    if (time1 === "10:00:00" && time2 === "18:00:00") {
      return days + 1;
    } else if (time1 === "18:00:00" && time2 === "10:00:00") {
      return days - 1;
    }
    return days;
  };

  renderRentals = (rentals, day, location) => {
    const morningOutgoingRentals = map(
      curry(this.renderRental)(true),
      filter(
        allPass([
          curry(this.isLocationIn)(location),
          curry(this.isMorning)("time_1"),
          curry(this.isIncoming)(day)
        ]),
        rentals
      )
    )

    const morningIngoingRentals = map(
      curry(this.renderRental)(false),
      filter(
        allPass([
          curry(this.isLocationOut)(location),
          curry(this.isMorning)("time_2"),
          curry(this.isOutcomming)(day)
        ]),
        rentals
      )
    )

    const afternoonOutgoingRentals = map(
      curry(this.renderRental)(true),
      filter(
        allPass([
          curry(this.isLocationIn)(location),
          curry(this.isAfternoon)("time_1"),
          curry(this.isIncoming)(day)
        ]),
        rentals
      )
    )

    const afternoonIngoingRentals = map(
      curry(this.renderRental)(false),
      filter(
        allPass([
          curry(this.isLocationOut)(location),
          curry(this.isAfternoon)("time_2"),
          curry(this.isOutcomming)(day)
        ]),
        rentals
      )
    )

    if (R.length(rentals) > 0) {
      return (
        <React.Fragment>
          {/* { this.renderSection('RENTALS') } */}
          {(!isEmpty(morningIngoingRentals) || !isEmpty(morningOutgoingRentals)) && this.renderSection("AM")}
          {morningOutgoingRentals}
          {morningIngoingRentals}
          {(!isEmpty(afternoonIngoingRentals) || !isEmpty(afternoonOutgoingRentals) ||
            !isEmpty(morningIngoingRentals) || !isEmpty(morningOutgoingRentals)
          ) && this.renderSection("PM")
          }
          {afternoonOutgoingRentals}
          {afternoonIngoingRentals}
          {/* {filter(
            allPass([
              curry(this.isIncoming)(day),
              curry(this.isLocationIn)(location),
              curry(this.isLocationOut)(location)
            ]),
            rentals
          ).length > 1
            ? this.buildLinkContracts(day, location, 2)
            : ""} */}
        </React.Fragment>
      );
    } else {
      return null;
    }
  };

  renderTransfers = (transfers, location) => {
    if (R.length(transfers) > 0) {
      return (
        <React.Fragment>
          <br />
          {this.renderSection("TRANSFERS", "#fca122")}
          {map(curry(this.renderDayTransfers)(location), transfers)}
        </React.Fragment>
      );
    }
    return null;
  };
  renderGuide = (guide, day, location) => {
    const filtered = guide.filter(x => x.location_id_1 === location);
    if (R.length(filtered) > 0) { 
            return (
              <React.Fragment>
                <br /> 
                {filter(allPass([curry(this.isIncomingGuide)(day),curry(this.isLocationIn)(location),
                  curry(this.isLocationOut)(location)]),filtered).length >= 1 ? 
                  this.renderSection("Guide Bike", "#66CCFF")
                        : ""} 
                {filter(allPass([curry(this.isIncomingGuide)(day),curry(this.isLocationIn)(location),
                  curry(this.isLocationOut)(location)]),filtered).length >= 1 ? 
                  map(curry(this.renderDayGuideBike)(location), filtered)
                        : ""} 
                {filter(allPass([curry(this.isIncomingGuide)(day),curry(this.isLocationIn)(location),
                  curry(this.isLocationOut)(location)]),filtered).length >= 1 ? 
                  this.buildLinkContractsGuide(day, location, 1)
                        : ""} 
              </React.Fragment>
            );
    }
    return null;
  };

  renderSection = (title, bgColor) => {
    return (
      <Section style={{ backgroundColor: bgColor ? bgColor : "" }}>
        {" "}
        {title}{" "}
      </Section>
    );
  };

  render() {
    const { day, location } = this.props;
    const allRentals = this.props.rentals;

    let rentals = R.filter(tour => {
      return (R.path(["booking", "tour_id"], tour) || 0) === 0;
    }, allRentals);

    const uniqueTransfers = this.props.transfers;
    const uniqueGuide = this.props.guideBike;
    const rentalTours = R.filter(tour => {
      return (R.path(["booking", "tour_id"], tour) || 0) > 0;
    }, allRentals);
    return (
      <React.Fragment>
        {this.renderRentals(rentals, day, location)}
        {this.renderTransfers(uniqueTransfers, location)}
        {this.renderTours(rentalTours, day, location )}
        {this.renderGuide(uniqueGuide, day, location )}
        <ClientDocumentsModal
          open={this.state.clientDocumentsModalOpen}
          onClose={this.closeClientDocuments}
          clientId={this.state.documentsClientId}
          rentalId={this.state.documentsRentalId}
        />
      </React.Fragment>
    );
  }
}

const RentalAgenda = props => (
  <WeekBoard
    title="Rental Agenda"
    resource="rentals"
    city="barcelona"
    dateField="date_1"
    filter={{ with_transfers: true }}
    card={ RentalAgendaCard }
  />
);

const mapStateToProps = function (state) {
  return {
    state: state
  };
};

export default connect(mapStateToProps)(RentalAgenda);



// WEBPACK FOOTER //
// ./src/components/rentalAgenda.js